import { loadStripe } from '@stripe/stripe-js'

export const stripe = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY)

export const appearance = {
    fonts: [
        {
            cssSrc: 'https://fonts.googleapis.com/css?family=Poppins',
        },
    ],
}
